import React from 'react'
import {motion} from 'framer-motion'
import * as FiIcons from 'react-icons/fi'
import SafeIcon from '../common/SafeIcon'

const {FiBookOpen} = FiIcons

const EmptyState = () => {
  return (
    <motion.div
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      transition={{duration: 0.5}}
      className="text-center py-16"
    >
      <div className="inline-flex items-center justify-center w-20 h-20 bg-secondary rounded-full mb-6 shadow-sm">
        <SafeIcon icon={FiBookOpen} className="text-3xl text-primary" />
      </div>
      
      <h3 className="text-2xl font-semibold text-gray-900 mb-3">
        Phoneme-Grapheme Mapper
      </h3>
      
      <p className="text-gray-600 max-w-md mx-auto leading-relaxed">
        Enter an English word above to see its grapheme and phoneme breakdown. 
        Perfect for teaching phonics and word structure.
      </p>
    </motion.div>
  )
}

export default EmptyState